import { useState, useEffect } from 'react';
import axios from 'axios';
const T = { bg:'#f0f5e8', cream:'#fffef0', greenDk:'#1b5e20', maroon:'#6d1b1b', orange:'#e65100', border:'#c8e6c9', header:'linear-gradient(135deg,#090b72,#1a237e)' };

const LagnasPage = () => {
  const [data, setData] = useState([]);
  const [sel, setSel] = useState(null);

  useEffect(() => {
    axios.get('/data/lagna-data.json').then(r => setData(r.data)).catch(() => {});
  }, []);

  const LAGNAS = ['மேஷம்','ரிஷபம்','மிதுனம்','கடகம்','சிம்மம்','கன்னி','துலாம்','விருச்சிகம்','தனுசு','மகரம்','கும்பம்','மீனம்'];

  return (
    <div style={{background:T.bg,minHeight:'80vh',padding:'10px'}}>
      <div style={{background:T.header,padding:'12px',borderRadius:'10px',textAlign:'center',marginBottom:'10px'}}>
        <img src="/images/rituals/Raasi-Mandalam.jpg" alt="ராசி" style={{height:'50px',borderRadius:'8px',marginBottom:'6px',border:'2px solid #f0d48a'}} />
        <h1 style={{color:'#fff',margin:0,fontSize:'1rem',fontWeight:900}}>🏛️ லக்னம் விவரங்கள்</h1>
        <div style={{color:'#c8e6c9',fontSize:'0.7rem'}}>Lagna / Ascendant Details</div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'4px',marginBottom:'10px'}}>
        {LAGNAS.map((l,i) => (
          <button key={i} onClick={()=>setSel(sel===i?null:i)} style={{
            border:'none',padding:'8px',borderRadius:'6px',cursor:'pointer',fontWeight:700,fontSize:'0.7rem',
            background:sel===i?T.greenDk:'#fff',color:sel===i?'#fff':T.greenDk,border:'1px solid '+T.border
          }}>{i+1}. {l}</button>
        ))}
      </div>
      {sel !== null && data.length > 0 && (
        <div style={{background:T.cream,padding:'10px',borderRadius:'8px',border:'1px solid '+T.border}}>
          <div style={{fontWeight:800,fontSize:'0.9rem',color:T.greenDk,marginBottom:'8px'}}>{LAGNAS[sel]} லக்னம்</div>
          {data.filter(d => d.Lagna === sel+1 || d.lagna === sel+1 || d.LagnaNo === sel+1).map((d,i) => (
            <div key={i} style={{background:'#fff',padding:'8px',borderRadius:'6px',marginBottom:'4px',border:'1px solid #eee',fontSize:'0.7rem'}}>
              {Object.entries(d).filter(([k])=>!['Lagna','lagna','LagnaNo','id'].includes(k)).map(([k,v])=>(
                <div key={k}><b style={{color:T.greenDk}}>{k}:</b> {String(v)}</div>
              ))}
            </div>
          ))}
          {data.filter(d => d.Lagna === sel+1 || d.lagna === sel+1 || d.LagnaNo === sel+1).length === 0 && (
            <div style={{fontSize:'0.75rem',color:T.maroon,lineHeight:1.6}}>
              <b>{LAGNAS[sel]}</b> லக்னத்தின் சிறப்பு பண்புகள், குணாதிசயங்கள், உடல் அமைப்பு, தொழில், திருமண வாழ்க்கை பற்றிய விரிவான தகவல்கள்.
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default LagnasPage;